import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useRef, useState } from "react";
import { MdArrowBack, MdArrowLeft, MdArrowRight, MdAttachFile, MdCheckBox, MdCheckBoxOutlineBlank, MdClose, MdFileCopy, MdFilePresent, MdForward, MdForward10, MdForwardToInbox, MdReply, MdSend } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { apiKey_g, web_url } from "../../constant";


function TranslatorMailRead({ t }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });

    const [content, setContent] = useState({
        messageId: "",
        threadId: "",
        subject: "",
        language: "",
        translatedSubject: "",
        other: '',
        type: '',
        attachments: [],
        moderatedAttachments: []
    });


    const [messagesArray, setmessagesArray] = useState([
        {
            messageId: "",
            sender: "",
            body: "",
            status: "",
            sentAt: "",
            language: "",
            type: "",
            attachments: [],
            moderatedAttachments: [],
            otherPerson: "",
            receiver: ''
        }
    ])
    const [indexOfMessageShowingNow, setIndexOfMessageShowingNow] = useState(0)

    const [isReceived, setIsReceived] = useState(false);

    const getLogDetails = () => {
        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
    };
    const logDetails = getLogDetails();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (localStorage.getItem('mailreceived')) {
            setIsLoading(true);
            const mail = JSON.parse(localStorage.getItem('mailreceived'));
            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };
            axios.get(`${web_url}/api/auth/students/${mail.other}`,configToken).then((resStuL) => {
                setIsLoading(false);
                // setContent(mail);
                setIsReceived(true);
                setContent({
                    ...mail,
                    language: resStuL.data.preferredLanguage,
                    moderatedAttachments: mail.attachments
                });
            }).catch((errorStuL) => {
                setIsLoading(false);
                handleClickOpenError("error occured");
            })
        }
    }, [])

    const [translatedMessage, setTranslatedMessage] = useState("")
    const [translatedSubject, setTranslatedSubject] = useState("")

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t214'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }], // Header options (H1, H2, and normal text)
            ['bold', 'italic', 'underline'], // Inline styles
            [{ list: 'ordered' }, { list: 'bullet' }], // Ordered and unordered lists
        ],
    };

    const navigate = useNavigate();


    const [reject, setReject] = useState(false);

    const [rejectMessage, setRejectMessage] = useState("");

    const [rejectError, setRejectError] = useState(false)

    const clickReport = () => {
        if (rejectMessage === "") {
            setRejectError(true);
            return;
        }
        rejectMail();

    }


    const rejectMail = () => {
        setIsLoading(true);
        let message_id = content.messageId;
        let thread_id = content.threadId;

         const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails2.token}`,
            },
        };
        const moderationData = {
            moderator: logDetails.email,
            action: "REJECTED",
            approvedAttachments: content.moderatedAttachments,
            reason: rejectMessage
        }
        axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=REJECTED`, moderationData, config).then((response) => {
            setIsLoading(false);
            setOpen6(true);
        }).catch((err) => {
            setIsLoading(false);
            handleClickOpenError("error occured");
        })

    }


    const forwardMail = () => {
        setIsLoading(true);
        let message_id = content.messageId;
        let thread_id = content.threadId;
        let emailUpdates = {};

        if (content.translatedSubject === "startMes") {
            emailUpdates = {
                translatedBody: translatedMessage,
                translatedSubject: translatedSubject
            }
        } else {
            emailUpdates = {
                translatedBody: translatedMessage
            }
        }

         const getLogDetails2 = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails2 = getLogDetails2();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${logDetails2.token}`,
            },
        };

        const moderationData = {
            moderator: logDetails.email,
            action: "APPROVED",
            approvedAttachments: content.moderatedAttachments
        }

        axios.patch(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}`, emailUpdates, config).then((response) => {
            axios.put(`${web_url}/api/email-threads/${thread_id}/messages/${message_id}/moderate?moderator=${logDetails.email}&action=APPROVED`, moderationData, config).then((response) => {
                setIsLoading(false);
                setOpen7(true);
            }).catch((err2) => {
                console.log('err2 - ', err2);

                setIsLoading(false);
                handleClickOpenError("error occured");
            })
        }).catch((err) => {
            setIsLoading(false);
            console.log('err1- ', err);

            handleClickOpenError("error occured");
        })

    }

    const handleChange = (value) => {
        setTranslatedMessage(value);
        // console.log(translatedMessage);

    };

    const handleTranslate = () => {
        setIsLoading(true);
        let languageNow = "";
        if (content.language.toLowerCase() === "english") {
            languageNow = "en"
        } else if (content.language.toLowerCase() === "sinhala") {
            languageNow = "si"
        } else if (content.language.toLowerCase() === "tamil") {
            languageNow = "ta"
        }

        const textAttr = {
            q: content.body,
            target: languageNow,
            format: "html",
        }

        const textAttr2 = {
            q: content.subject.trim(),
            target: languageNow,
            format: "html",
        }

        // console.log('attr', textAttr);

        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        axios.post(
            `https://translation.googleapis.com/language/translate/v2?key=${apiKey_g}`,
            textAttr, config
        ).then((response) => {

            if (content.subject.trim()) {
                axios.post(
                    `https://translation.googleapis.com/language/translate/v2?key=${apiKey_g}`,
                    textAttr2, config
                ).then((response2) => {
                    setIsLoading(false);
                    setTranslatedMessage(response.data.data.translations[0].translatedText)
                    setTranslatedSubject(response2.data.data.translations[0].translatedText)
                    setOpen5(true);
                }).catch((err2) => {
                    setIsLoading(false);
                    // console.log('error', err);

                    handleClickOpenError("error occured")
                })
            } else {
                setIsLoading(false);
                setTranslatedMessage(response.data.data.translations[0].translatedText)
                setOpen5(true);
            }

            // setIsLoading(false);
            // setTranslatedMessage(response.data.data.translations[0].translatedText)
            // setOpen5(true);
        }).catch((err) => {
            setIsLoading(false);
            // console.log('error', err);

            handleClickOpenError("error occured")
        })

    };

    const [open5, setOpen5] = useState(false)

    const handleClose5 = () => {
        setOpen5(false);
    }

    const [open6, setOpen6] = useState(false)

    const handleClose6 = () => {
        setOpen6(false);
        localStorage.setItem("refresh", `${Date.now()}`);
        navigate('/mobile/translator/translatemail/inbox')
    }

    const [open7, setOpen7] = useState(false)

    const handleClose7 = () => {
        setOpen7(false);
        localStorage.setItem("refresh", `${Date.now()}`);
        navigate('/mobile/translator/translatemail/inbox')
    }

    const handleDownload = async (fileName, fileUrl) => {
        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();

            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Download failed:", error);
        }
    };

    return (
        <>
            <div className="xl:bg-[#FFEBA9] xl:rounded-md mb-[200px] xl:mb-[10px] pl-[30px] xl:pl-[20px] xl:ml-[0px] 2xl:pl-[30px] pr-[30px] xl:pr-[20px] 2xl:pr-[30px] xl:mr-[80px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[1px] 2xl:pt-[5px] xl:pb-[20px] 2xl:pb-[30px] 2xl:pt-[0px] xl:mt-[20px] 2xl:mt-[30px]">
                <div className="flex items-center mt-[20px] lg:ml-[70px] xl:ml-[0px] justify-between">
                    <div className="flex items-center justify-between w-full  md:mr-[30px] lg:mr-[130px]">
                        <div className="flex items-center">
                            <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                navigate('/mobile/translator/translatemail/inbox')
                            }} />
                            <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                navigate('/mobile/translator/translatemail/inbox')
                            }} />
                            <p className="font-bold text-[20px] ml-[10px] md:text-[20px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px]">{t('t234')}</p>
                        </div>
                    </div>
                </div>

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    {isReceived &&
                                        <p className={`text-gray-500 text-[15px]`}>{t('t235')}:</p>
                                    }

                                    {
                                        isReceived && <input value={content.sender} readOnly type="text" name="receptionist" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0"
                                        />
                                    }

                                </div>
                            </div>

                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                    <input readOnly value={(content.subject.trim()) ? content.subject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.subject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center justify-center">
                                <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                    <p className={`text-gray-500 text-[15px] whitespace-nowrap`}>{t('t416')}:</p>
                                    <input readOnly value={(content.language) ? content.language : "(No lanuage)"} type="text" name="language" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${content.language ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t416')}
                                    />
                                </div>
                            </div>

                            <div className="mt-[20px] md:px-[200px] lg:px-[350px] xl:pl-[10px] flex flex-col gap-[5px] mb-[10px]">
                                {/* {
                                    content.attachments &&
                                    <>
                                        {(content.attachments).map((file, index) => (
                                            <div key={index} className="flex items-center justify-between">
                                                <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                    <MdFilePresent />
                                                    <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                </div>

                                            </div>
                                        ))}
                                    </>
                                } */}
                                {
                                    content.attachments &&
                                    <>
                                        {content.attachments.map((file, index) => {
                                            const isSelected = content.moderatedAttachments.some(
                                                attachment => attachment.fileUrl === file.fileUrl
                                            );

                                            return (
                                                <div key={index} className="flex items-center justify-between">
                                                    {/* File Download Section */}
                                                    <div className="flex items-center cursor-pointer" onClick={() => handleDownload(file.fileName, file.fileUrl)}>
                                                        <MdFilePresent />
                                                        <p className="text-black text-[15px] md:text-[17px]">{file.fileName}</p>
                                                    </div>

                                                    {/* Selection Toggle */}
                                                    <div className="pr-[10px]">
                                                        {!isSelected ? (
                                                            <MdCheckBoxOutlineBlank
                                                                className="cursor-pointer"
                                                                onClick={() =>
                                                                    setContent(prev => ({
                                                                        ...prev,
                                                                        moderatedAttachments: [...prev.moderatedAttachments, file]
                                                                    }))
                                                                }
                                                            />
                                                        ) : (
                                                            <MdCheckBox
                                                                className="cursor-pointer"
                                                                onClick={() =>
                                                                    setContent(prev => ({
                                                                        ...prev,
                                                                        moderatedAttachments: prev.moderatedAttachments.filter(
                                                                            attachment => attachment.fileUrl !== file.fileUrl
                                                                        )
                                                                    }))
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>
                                }

                            </div>

                            <div className="md:flex md:justify-center md:items-center">
                                <div className="justify-center items-center w-full md:w-[600px]">
                                    <ReactQuill
                                        modules={{ toolbar: false }}
                                        value={content.body}
                                        readOnly
                                        theme="snow"
                                        placeholder={t('t225')}
                                        className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                </div>
                            </div>

                            {
                                content?.moderationRecord?.reason &&
                                <div className="md:flex md:justify-center md:items-center">
                                    <div className="items-center mt-[20px] flex md:w-[600px] md:justify-center">
                                        <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] text-[#1F2937] shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                            rows={7} cols={40}
                                            placeholder="Reason for rejection"
                                            readOnly
                                            value={`Rejected reason : \n${JSON.parse(content?.moderationRecord?.reason || '{}')?.reason || ''}`}
                                        />
                                    </div>
                                </div>
                            }

                            {
                                translatedMessage &&
                                <>
                                    {
                                        content.translatedSubject === "startMes" &&
                                        <div className="flex items-center justify-center">
                                            <div className="w-full md:w-[600px] items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-400 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                                <p className={`text-gray-500 text-[15px]`}>{t('t236')}:</p>
                                                <input value={translatedSubject.trim() ? translatedSubject.trim() : "(No subject)"} type="text" name="subject" className={`ml-[10px] w-full bg-[#F1F6FB] text-[15px] ${translatedSubject.trim() ? 'text-gray-900' : 'text-gray-500'} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t224')}
                                                />
                                            </div>
                                        </div>
                                    }

                                    <div className="md:flex md:justify-center md:items-center pt-[20px]">
                                        <div className="justify-center items-center w-full md:w-[600px]">
                                            <ReactQuill
                                                value={translatedMessage}
                                                onChange={handleChange}
                                                modules={modules}
                                                theme="snow"
                                                placeholder="Message"
                                                className="rounded-lg min-h-[400px] xl:min-h-[300px] 2xl:min-h-[500px] w-full mt-[5px] bg-[#F1F6FB] border border-gray-400 focus-within:shadow-[0_0_0_2px_rgba(156,163,175,1)]" />
                                        </div>
                                    </div>
                                </>
                            }

                            {
                                !translatedMessage ?
                                    <div className="flex justify-center items-center">
                                        <button onClick={() => {
                                            handleTranslate()
                                        }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Translate</button>

                                    </div>
                                    :
                                    <div className="flex justify-center items-center">
                                        <button onClick={() => {
                                            handleTranslate()
                                        }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Translate again</button>

                                    </div>
                            }

                            {
                                content.type === 'PENPAL' && content.status === "PENDING" && translatedMessage &&
                                <div className="flex justify-center items-center gap-[20px]">
                                    <button onClick={() => {
                                        setReject(true)
                                    }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">{t('t350')}</button>

                                    <button onClick={() => {
                                        forwardMail();
                                    }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">{t('t351')}</button>

                                </div>
                            }

                            {
                                content.type === 'PENPAL' && content.status === "REJECTED" && translatedMessage &&
                                <div className="flex justify-center items-center">
                                    <button onClick={() => {
                                        forwardMail();
                                    }} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[200px] hover:bg-opacity-80 bg-gradient-to-r from-[#FFA803] to-[#FFD12E]">Approve and forward</button>

                                </div>
                            }

                            {
                                reject &&
                                <div className="md:flex md:justify-center md:items-center">
                                    <div className="items-center mt-[20px] flex md:w-[600px] md:justify-center">
                                        <textarea className={` rounded-md w-full bg-[#F1F6FB] text-[15px] ${rejectMessage === "" ? 'text-gray-400' : 'text-[#1F2937]'} shadow-sm ring-1 ring-inset ring-gray-400 hover:bg-gray-100 pr-[30px] focus:border-none focus:outline-none py-[5px] px-[20px]`}
                                            rows={7} cols={40}
                                            placeholder="Reason for rejection"
                                            onChange={(e) => (
                                                setRejectMessage(e.target.value)
                                            )}
                                        />
                                    </div>
                                </div>
                            }

                            {(rejectError) &&
                                <p className='text-[#ff0000] text-[12px] mt-[5px] md:mx-[70px] lg:mx-[180px]'>State reasons for rejection</p>
                            }
                            {
                                reject &&
                                <div className="flex justify-center gap-[20px] ml-[20px] mr-[20px] md:mx-[150px] lg:mx-[250px] xl:mx-[400px] 2xl:mx-[600px] mt-[20px] md:mt-[20px] xl:mt-[60px] 2xl:mt-[150px]">
                                    <button onClick={clickReport} className="text-[18px] mt-[20px] rounded-lg pt-[10px] pb-[10px] w-[400px] hover:bg-opacity-80 bg-[#F2290E] bg-opacity-20">Report</button>
                                </div>
                            }
                        </>
                }


            </div >
            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open5}
                onClose={handleClose5}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t277')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose5}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open6}
                onClose={handleClose6}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t278')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose6}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open7}
                onClose={handleClose7}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >

                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {t('t279')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleClose7}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t7')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TranslatorMailRead;
